import $ from 'jquery';
import YTPlayer from './yt-player';

export default class Video {
	static defaultOptions = {
		selector: '.video',
		elClass: 'video'
	}

	constructor(options) {
		this.options = {
			...this.constructor.defaultOptions,
			...options
		};
		this.players = [];

		$(this.options.selector).each(this.initPlayer);
	}

	initPlayer = (id, block) => {
		const {selector} = this.options;
		const $block = $(block);

		this.players[id] = {
			playing: false,
			$block
		};

		const $overlay = $block.find(`${selector}__overlay`);
		const $player = $block.find(`${selector}__player`);
		const videoId = $player.data('video-id');

		this.players[id].player = new YTPlayer($player.get(0), {
			width: 946,
			height: 532,
			controls: false,
			fullscreen: false,
			annotations: false,
			related: false,
			info: false
		});

		this.players[id].player.load(videoId, false);
		this.players[id].player.on('ended', this.onVideoEnd(this.players[id]));
		$overlay.click(this.onOverlayClick(this.players[id]));
	}

	onOverlayClick = currentPlayer => () => {
		const {elClass} = this.options;
		const {player, $block, playing} = currentPlayer;
		$block.addClass(`${elClass}_started`);

		if (playing) {
			player.pause();
			$block.addClass(`${elClass}_paused`);
		}else {
			player.play();
			$block.removeClass(`${elClass}_paused`);
		}
		currentPlayer.playing = !playing;
	}

	onVideoEnd = currentPlayer => () => {
		const {elClass} = this.options;
		currentPlayer.playing = false;
		currentPlayer.$block.removeClass(`${elClass}_started`);
	}

	static init(options) {
		const instance = new Video(options);

		return instance;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/video/index.js